import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Redirect } from 'react-router';
import LoaderMain from '../Onboarding/shared/LoaderMain';
import { autenthicaToken } from '../../api/authentication';
import { setDesabilitarMenuSession } from '../../shared/services/User';

const PlataformasAutenticacao = ({ setEscopoAcesso }) => {
  const [urlRedirect, setUrlRedirect] = useState(false);
  const [isPending, setPending] = useState(true);
  const { token, tokenRefresh, url } = useParams();

  useEffect(() => {
    setPending(true);

    autenthicaToken(token, tokenRefresh, setEscopoAcesso)
      .then(res => {
        if (res) {
          setDesabilitarMenuSession();
          const urlTemp = url.replaceAll('|', '/');
          setUrlRedirect(urlTemp);
        } else {
          sessionStorage.clear();
          throw new Error('Erro ao autenticar');
        }
      })
      .catch(() => {
        sessionStorage.clear();
        setUrlRedirect('/login');
      })
      .finally(() => {
        setPending(false);
      });
  }, []);
  return (
    <>
      {isPending && <LoaderMain tipoLoader="float" tipoImagem="logo" />}
      {urlRedirect && <Redirect to={urlRedirect} replace />}
    </>
  );
};

export default PlataformasAutenticacao;
